module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/src/assets/global/plugins/bootstrap/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/global/plugins/bootstrap/fonts/bootstrap/glyphicons-halflings-regular.woff
// module chunks = styles